<template>
  <div id="app" class="v-content__wrap">
    <loader v-if="loading" />

    <Header v-if="showHeaderAndFooter" />

    <router-view />
    <AudioSection />
    <!-- <Subscriber v-if="showSubscriber" /> -->
    <!-- <FooterSlider  v-if="showFooterSlider"/> -->
    <Footer v-if="showHeaderAndFooter" />
  </div>
</template>
<script>
import Header from "@/components/Header/Header";
import Footer from "@/components/Footer/Footer";
// import Subscriber from "Components/Sections/Subscriber";
import loader from "Components/Sections/loader";
import jwt from "@/http/requests/auth/jwt/index.js";
import AudioSection from "Components/Sections/AudioSection.vue";

export default {
  data() {
    return {
      showHeaderAndFooter: true,
      showSubscriber: true,
      //   showFooterSlider: true
    };
  },
  components: {
    Header,
    Footer,
    loader,
    // Subscriber,
    AudioSection,
  },
  computed: {
    loading() {
      debugger
      return this.$store.state.loading;
    },
  },
  methods: {
    showSuccess() {
      this.$vs.notify({
        color: "success",
        position: "top-center",
        title: this.$t("Update"),
        text: this.$t("showUpdate"),
      });
    },
    getUrl() {
      let val = this.$route.path.split("/");
      if (
        val[1] == "login" ||
        val[1] == "signup" ||
        val[1] == "thank-you" ||
        val[1] == "maintenance" ||
        val[1] == "not-found"
      ) {
        this.showHeaderAndFooter = false;
        this.showFooterSlider = false;
      } else {
        this.showHeaderAndFooter = true;
        this.showFooterSlider = true;
      }
    },
    showSubs() {
      let val = this.$route.path.split("/");
      if (
        val[1] == "home" ||
        val[1] == "login" ||
        val[1] == "signup" ||
        val[1] == "thank-you" ||
        val[1] == "maintenance" ||
        val[1] == "not-found"
      ) {
        this.showSubscriber = false;
      } else {
        this.showSubscriber = true;
      }
    },
  },
  mounted() {
    this.getUrl();
    this.showSubs();
  },
  watch: {
    $route() {
      this.getUrl();
      this.showSubs();
    },
  },
  created() {
    jwt.init();
    window.showSuccess = this.showSuccess;

    window.store = this.$store;
    if (localStorage.getItem("SaveLang") === "ar") {
      document.querySelector("body").classList.toggle("rtl-enable");
    }
  },
};
</script>
<style>
.btn-primary:active {
  background-color: #f78500 !important;
  background: #f78500 !important;
  /*  */
}
.btn-primary:focus {
  background-color: #f78500 !important;
  background: #f78500 !important;
  /*  */
}

</style>
